import React, { useEffect } from 'react';
import './Techconsulting.css';

const Techconsulting = () => {
    useEffect(() => {
        console.log('Techconsulting useEffect running');
        const elements = document.querySelectorAll('.animate-on-scroll');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    console.log(`${entry.target.className} isIntersecting: ${entry.isIntersecting}`);
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate');
                    }
                });
            },
            { threshold: 0.2 }
        );

        elements.forEach((element) => {
            console.log('Observing:', element);
            observer.observe(element);
        });

        return () => {
            elements.forEach((element) => observer.unobserve(element));
        };
    }, []);

    const keyTopics = [
        {
            title: "Technology Strategy Development Process",
            description: "Crafting strategic technology plans to align IoT solutions with business goals."
        },
        {
            title: "IoT Solution Architecture Process",
            description: "Designing scalable architectures for IoT and embedded system deployments."
        },
        {
            title: "System Optimization Consulting Process",
            description: "Optimizing IoT systems for performance, efficiency, and reliability."
        },
        {
            title: "Cybersecurity Consulting Process",
            description: "Providing expertise to secure IoT and embedded systems against threats."
        },
        {
            title: "Cloud Integration Consulting Process",
            description: "Guiding seamless integration of IoT solutions with cloud platforms."
        },
        {
            title: "Embedded Systems Design Consulting Process",
            description: "Advising on efficient embedded system designs for IoT applications."
        },
        {
            title: "Regulatory Compliance Consulting Process",
            description: "Ensuring IoT solutions meet industry standards and regulations."
        },
        {
            title: "Digital Transformation Consulting Process",
            description: "Driving digital transformation through IoT and embedded technologies."
        },
        {
            title: "Technology Roadmap Planning Process",
            description: "Planning long-term technology roadmaps for IoT solution success."
        }
    ];

    return (
        <div className="detail-page">
            <h1 className="detail-heading animate-on-scroll" style={{ animationDelay: '0.1s' }}>
                Technology Consulting
            </h1>
            <p className="detail-intro animate-on-scroll" style={{ animationDelay: '0.2s' }}>
                Our technology consulting services provide strategic guidance and technical expertise for IoT and embedded systems, empowering businesses to achieve innovative and reliable solutions.
            </p>
            <h2 className="detail-subheading animate-on-scroll" style={{ animationDelay: '0.3s' }}>
                Key Topics
            </h2>
            <ul className="detail-topics">
                {keyTopics.map((topic, index) => (
                    <li
                        key={index}
                        className="topic-card animate-on-scroll"
                        style={{ animationDelay: `${0.4 + index * 0.05}s` }}
                    >
                        <strong className="topic-title">{topic.title}</strong>
                        <p className="topic-description">{topic.description}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Techconsulting;